import { $ } from '../lib/dom.js';
import { reduceMotion, supportsScrollTimeline } from '../lib/env.js';

/* Barra de progreso del scroll.
   En navegadores con scroll-driven animations la resuelve el CSS
   (`animation-timeline: scroll()`); acá está sólo el fallback. */
export function initProgress() {
  if (supportsScrollTimeline || reduceMotion) return;

  const progress = $('[data-progress]');
  if (!progress) return;

  let ticking = false;

  function update() {
    ticking = false;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const s = max > 0 ? window.scrollY / max : 0;
    progress.style.setProperty('--pv-scroll', Math.min(1, Math.max(0, s)).toFixed(4));
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
}
